"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._PerformFitpayPayment = exports._RegularOnboarding = void 0;
var api_wrapper_1 = require("@src/api/api-wrapper");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var object_service_1 = require("@src/services/object-service");
var translation_1 = __importDefault(require("@src/services/translation"));
var _RegularOnboarding = function (user) { return __awaiter(void 0, void 0, void 0, function () {
    var newCustomer;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                //CREATE REGULAR CUSTOMER
                console.log('creating customer');
                return [4 /*yield*/, object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper).createNewCustomer(user)];
            case 1:
                newCustomer = _a.sent();
                console.log('created customer', newCustomer);
                // if (guardianRes?.valid === false && guardianRes?.data) {
                //   //CRIT: CREATE PUBLIC MAGICLINE CLASS
                //   //ObjectService.getInstance(PublicMagicline).startProcess(newCustomer, guardianRes.data);
                // }
                if (newCustomer === null || newCustomer === void 0 ? void 0 : newCustomer.error) {
                    (0, generator_const_1._ShowErrorMessage)('' + typeof (newCustomer === null || newCustomer === void 0 ? void 0 : newCustomer.error) === 'string' ? translation_1.default.t(newCustomer.error) : 'Sorry but please try again later');
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
        }
    });
}); };
exports._RegularOnboarding = _RegularOnboarding;
var _PerformFitpayPayment = function (stripePayment, user) { return __awaiter(void 0, void 0, void 0, function () {
    var stripeRes, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                (0, generator_const_1._CreateLoadingScreen)();
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                console.log('starting stripe payment');
                return [4 /*yield*/, stripePayment.startPaymentProcess(user)];
            case 2:
                stripeRes = _a.sent();
                console.log('payment res', stripeRes);
                if (stripeRes.success === false) {
                    (0, generator_const_1._DeleteLoadingScreen)();
                    (0, generator_const_1._ShowErrorMessage)(translation_1.default.t(stripeRes.message));
                }
                return [2 /*return*/, stripeRes.success];
            case 3:
                e_1 = _a.sent();
                console.error('stripe payment error', e_1);
                (0, generator_const_1._ShowErrorMessage)(typeof e_1 === 'string' ? e_1 : 'Payment failed');
                (0, generator_const_1._DeleteLoadingScreen)();
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports._PerformFitpayPayment = _PerformFitpayPayment;
